export default __webpack_public_path__ + "static/media/homepage-ordi.4fe96eb7.png";